import React from 'react';
import { MultiStepModal } from '@components/common/multiStepModal';

import { AccountTypePickerModalStep } from './steps/accountTypePickerModalStep';
import { AccountTypeFormModalStep } from './steps/accountTypeFormModalStep';
import { useDesignVariant } from '../designVariantContext';

interface CreateAccountModalProps {
  open: boolean;
  onClose: () => void;
}

export const CreateAccountModal: React.FC<CreateAccountModalProps> = ({ open, onClose }) => {
  const variant = useDesignVariant();

  return (
    <MultiStepModal
      showCross
      variant={variant}
      steps={[
        {
          key: 'accountTypePicker',
          title: 'Create account to connect',
          component: () => <AccountTypePickerModalStep />,
        },
        {
          key: 'accountTypeForm',
          title: 'Configure account',
          component: () => <AccountTypeFormModalStep />,
        },
      ]}
      open={open}
      onClose={onClose}
      breadcrumb={{ hide: true }}
      size="lg"
    />
  );
};
